<template>
  <div class="home-teacher-page">
    <df-loading v-if="isLoad" class="loading"></df-loading>
    <div class="home-teacher-detail" v-else>
      <div class="detail flex">
        <div class="avatar ovh">
          <img :src="info.bigimg" v-df-avatar="defaultTeacherImg" alt="" class="avatar-inner vam w100 h100"/>
        </div>
        <div class="content flex-1 lh1 pt10">
          <div class="name flex aic">
            <div class="name-inner">{{info.name}}</div>
            <div class="name-follow csp flex aic" @click="follow"><i class="mine-ico hart"></i>{{info.is_follow
              ? '已' : ''}}关注
            </div>
          </div>
          <div class="fans" v-show="info.follow_count">{{info.follow_count}}粉丝</div>
          <div class="labels flex">
            <div class="label flex aic">
              <i class="mine-ico xz"></i>
              <span>{{info.zhicheng}}</span>
            </div>
            <div class="label" v-for="(label, i) in info.personality_label" :key="i">{{label}}</div>
          </div>
          <!--<div class="remark wot4">{{info.content}}</div>-->
          <more-text class="remark" row="3" :text="info.content || ''"></more-text>
        </div>
      </div>
      <div class="course-list">
        <div class="title flex aic">
          <span>教授课程</span>
          <span class="count">共{{total}}个课程</span>
        </div>
        <div class="list flex fww">
          <course-card :item="course" v-for="(course, i) in list" image-width="149" image-height="170"
                       width="149"
                       hidden-audio
                       img-key="bgimg"
                       :key="i" is-custom-label @detail="changeJumpEvent(course)">
            <template #image="{item}">
              <div class="course-image-box">
                <i class="mine-ico poa audio img" v-show="item.format_id === 2"></i>
              </div>
            </template>
          </course-card>
        </div>
        <df-page @change="e => curr = e" :total="total" :current="curr"
                 :page-size="limits"></df-page>
      </div>
    </div>
    <div class="ovh" style="height: 0">dd</div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import Mixins from '../../../../mixins/mixins'

  export default {
    name: "HomeTeacherDetail",
    mixins: [Mixins.MakeRoute({id: 'tid'}, 'params', 'replace')],
    computed: {
      ...mapGetters(['userInfo']),
      list() {
        return this.info.course_list ? this.info.course_list.slice((this.curr - 1) * this.limits, this.curr * this.limits) : [];
      },
      pages() {
        return Math.ceil(this.total / this.limits) || 0;
      },
    },
    data() {
      return {
        defaultTeacherImg: require('@/assets/images/details/default_user.png'),
        info: {},
        total: 0,
        curr: 1,
        limits: 14,
        isLoad: true,
      };
    },
    methods: {
      getInfo() {
        this.http.NEWInfo({
          uid: this.userInfo.uid,
          ...this.Product,
          id: this.tid,
        }).then(res => {
          for (let i = 0; i > 0; i--) {
            // res.info.course_list = [
            //   ...res.info.course_list,
            //   ...res.info.course_list,
            // ];
            res.info.content += res.info.content;
          }
          this.info = res.info;
          this.total = this.info.course_list.length;
        }).catch(this.$err).finally(() => { this.isLoad = false });
      },
      follow() {
        if(!this.userInfo.uid){
          return this.ShowToast('需要登录才能关注!');
        }
        this.http.NEWFollow({
          uid: this.userInfo.uid,
          teacher_id: this.tid,
          ...this.Product,
        }).then(r => {
          this.ShowToast(+r.status === 1 ? '关注成功' : '取消关注');
          this.info.is_follow = +r.status === 1;
          if (this.info.is_follow) {
            this.info.follow_count++;
          } else {
            this.info.follow_count--;
          }
        }).catch(this.$err);
      },
      // 课程跳转
      changeJumpEvent (item) {
        this.OpenRouter(`/home/${item.format_id === 1 ? 'video' : 'audio'}/details/${item.id}/${item.type}`);
      },
    },
    created() {
      this.getInfo();
      this.$emit('set-background-color', '#F5FCFF');
    },
  }
</script>

<style scoped lang="less">
  @import "../../../../assets/less/function";

  .loading{
    padding: 200px 0;
    /deep/ .loading-tip{
      color: #333;
    }
  } 

  .list {
    margin: -26px 0 0 -16px;
  }
  /deep/ .page-box{
    padding: 64px 0;
  }
  .course-card {
    margin: 26px 0 0 16px;
    // /deep/ .vip-type-tip {
    //   display: none;
    // }
    /deep/ .detail-box {
      padding: 0;
      .name {
        padding-top: 10px;
        font-size: 14px;
        color: #333f4e;
      }
    }
  }

  .title {
    margin-bottom: 24px;
    font-size: 18px;
    color: #333f4e;
    .count {
      margin-left: 18px;
      font-size: 14px;
      color: #666f7a;
    }
  }

  .home-teacher-page {
    padding: 0;
  }

  .home-teacher-detail {
    margin: 46px auto 64px !important;
    padding: 30px 28px 0 29px;
    background-color: #fff;
    border-radius: 8px;
  }

  .detail {
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #eee;
  }

  .mine-ico {
    &.img {
      .spirit(url(../../../../assets/images/search_icon.png));
    }
    &:not(.img) {
      .spirit-mask(url(../../../../assets/images/search_icon.png));
    }
    &.hart {
      &:after {
        margin-right: 3px;
        width: 11px;
        height: 11px;
        mask-position: -34px -4px;
        background-color: #FF5776;
      }
    }
    &.audio {
      &:after {
        margin-right: 0;
        width: 25px;
        height: 25px;
        background-position: -77px -2px;
      }
    }
    &.xz {
      &:after {
        margin-right: 4px;
        width: 26px;
        height: 24px;
        mask-position: -103px -1px;
        background-color: #ff5776;
      }
    }
  }

  .avatar {
    margin-right: 30px;
    width: 164px;
    height: 164px;
    border-radius: 8px;
  }

  .content {
    .name {
      margin-bottom: 15px;
      font-size: 24px;
      color: #333f4e;
    }
    .name-follow {
      margin-left: 24px;
      padding: 0 15px;
      height: 22px;
      line-height: 0;
      color: #ff5776;
      font-size: 12px;
      background: #FFFFFF;
      border: 1px solid #FF5776;
      border-radius: 24px;
      &:hover {
        border-color: #FF3B5F;
        color: #ff3b5f;
        .hart {
          &:after {
            background-color: #ff3b5f;
          }
        }
      }
    }
    .fans {
      margin-bottom: 31px;
      color: #999fa6;
      font-size: 14px;
      &.no {
        opacity: 0;
      }
    }
    .labels {
      margin-bottom: 13px;
    }
    .label {
      padding: 0 16px;
      height: 24px;
      font-size: 14px;
      line-height: 24px;
      color: #ff5776;
      background-color: #ffe9ed;
      border-radius: 24px;
      &:not(:last-child) {
        margin-right: 16px;
      }
      &:first-child {
        padding-left: 0;
      }
      &:nth-child(4n + 2) {
        background-color: #f8dbff;
        color: #d92dff;
      }
      &:nth-child(4n + 3) {
        background-color: #fff3d7;
        color: #ff9500;
      }
      &:nth-child(4n + 4) {
        background-color: #d0ffe8;
        color: #01c562;
      }
    }
    .remark {
      font-size: 14px;
      color: #666f7a;
      line-height: 22px;
      /deep/ .end-length {
        .last-row {
          display: none;
        }
      }
    }
  }

  .course-image-box {
    .audio {
      left: 8px;
      bottom: 5px;
    }
  }
</style>